import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { globalRequest } from "../../../utils/global/globalRequest";
import { USERS } from "../../../utils/helper/Enum";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../redux/reducers/loader";
import { changeTrigger } from "redux/reducers/trigger";
import { setSnackbar } from "../../../redux/reducers/snackbar";
import { getAuth } from "../../../redux/reducers/loginData";
import {
  Button,
  DatepickerInput,
  Img,
  Input,
  MobileInput,
  Text,
} from "components";
import {
  getMobileNo,
  validateForm,
  strFormat,
  replaceKeyValue,
  refreshToken,
  getLoginDataByKey,
  isValidMobile,
} from "../../../utils/helper/custom";
import { useNavigate } from "react-router-dom";

const ProfileEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let auth = useSelector(getAuth);
  const [errors, setErrors] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [profileData, setProfileData] = React.useState(null);
  const [profileFieldData, setProfileFieldData] = React.useState(null);
  const [mobileStep, setMobileStep] = React.useState("old");
  const [changeNumber, setChangeNumber] = React.useState(false);
  const [timer, setTimer] = useState(0);

  /**
   * get profile data
   */
  const getProfile = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        USERS?.GET_PROFILE,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      setChangeNumber(false);
      if (response?.status == "SUCCESS") {
        setProfileData(response?.data);
        return true;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   * get profile data
   */
  const updateProfile = async (e) => {
    e.preventDefault();
    let validationErrors = validateForm(profileFieldData, "profile", t);
    if (Object.keys(validationErrors).length !== 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      dispatch(changeLoader(true));
      let inputData = profileFieldData;
      let response = await globalRequest(
        USERS?.UPDATE_PROFILE,
        "PUT",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        setOpen(false);
        getProfile();
        await refreshToken();
        dispatch(changeTrigger("profileUpdated"));
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
        return true;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   * send otp
   */
  const SendOtp = async (e) => {
    e.preventDefault();
    let mobileValidation = isValidMobile(profileFieldData?.mobile_no, t);
    if (Object.keys(mobileValidation).length > 0) {
      setErrors(mobileValidation);
      return;
    }
    setChangeNumber(false);
    try {
      dispatch(changeLoader(true));
      let inputData = profileFieldData;
      let response = await globalRequest(
        USERS?.SEND_OTP,
        "post",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        setTimer(process.env.REACT_APP_OTP_TIMER);
        setChangeNumber(true);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
        return true;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   * verify otp
   */
  const verifyOtp = async () => {
    //e.preventDefault();
    //setChangeNumber(false);
    try {
      dispatch(changeLoader(true));
      let inputData = profileFieldData;
      let response = await globalRequest(
        USERS?.VERIFY_OTP,
        "post",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        setChangeNumber(false);
        setTimer(0);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
        setProfileFieldData({
          ...profileFieldData,
          mobile_no: "",
          otp: "",
          type: "new",
          email: profileFieldData?.email,
        });
        setMobileStep("new");
        return;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   * update mobile no
   */
  const updateMobileNo = async () => {
    //e.preventDefault();
    //setChangeNumber(false);
    try {
      dispatch(changeLoader(true));
      let inputData = profileFieldData;
      let response = await globalRequest(
        USERS?.UPDATE_MOBILE_NUMBER,
        "put",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        await refreshToken();
        setOpen(false);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
        setProfileFieldData({
          ...profileFieldData,
          type: "old",
          otp: "",
        });
        setMobileStep("old");
        setChangeNumber(false);
        handleClose();
        return;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   * open profile modal
   */
  const handleOpen = () => {
    getProfile();
    setOpen(true);
  };

  /**
   * close profile modal
   */
  const handleClose = () => {
    setErrors({});
    setOpen(false);
  };

  /**
   * timer set for otp
   */
  useEffect(() => {
    let interval;
    const countdown = () => {
      if (timer > 0) {
        setTimer((prevTimer) => prevTimer - 1);
      }
    };
    interval = setInterval(countdown, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  /**
   * reset on modal close
   */
  useEffect(() => {
    if (open == false) {
      setMobileStep("old");
      setErrors({});
    }
  }, [open]);

  /**
   * update profile field data
   */
  useEffect(() => {
    if (profileData !== null) {
      setProfileFieldData({
        first_name: profileData?.firstName,
        last_name: profileData?.lastName,
        mobile_no: getMobileNo(profileData?.mobileNo, "number"),
        country_code: getMobileNo(profileData?.mobileNo, "code"),
        dob:
          profileData?.userDetail !== null ? profileData?.userDetail?.dob : "",
        email: profileData?.email == null ? "" : profileData?.email,
        otp: "",
        type: "old",
      });
    }
  }, [profileData]);

  return (
    <>
      <div className="flex flex-row font-nunitomedium md:gap-10 items-center justify-between max-w-[1142px] px-4 mt-7 mb-7 mx-auto w-full">
        <div className="flex flex-col items-start justify-start">
          <Text
            className="text-2xl font-['Unbounded'] md:text-[22px] text-black-900 sm:text-xl"
          >
            {getLoginDataByKey("fullname")}
          </Text>
          <Text
            className="text-black-900 text-sm font-['Inter']"
          >
            {replaceKeyValue(auth?.mobileNo, "-", "")}
          </Text>
        </div>
        <Button
          className="w-10 h-10 rounded-full flex items-center justify-center bg-[white] border border-gray-300 p-0"
          size="md"
          variant="OutlineBlack"
          onClick={handleOpen}
          hover={true}
          hoverclass="bg-pink-300"
        >
          <Img src="/images/editIcon.svg" alt="edit" />
        </Button>
      </div>

      {profileData != null ? (
        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
              sx: {
                backdropFilter: "blur(8px)",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
              },
            },
          }}
        >
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-[480px] bg-[white] rounded-2xl shadow-2xl p-0 outline-none">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">
                {t("editProfile") || "Editing Profile"}
              </h2>
              <button
                onClick={handleClose}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-8 py-6 max-h-[calc(100vh-200px)] overflow-y-auto">
              <form onSubmit={updateProfile} className="space-y-5">
                <Input
                  label={t("firstName") || "First Name *"}
                  placeholder="Enter your first name"
                  required
                  value={profileFieldData?.first_name}
                  onChange={(e) => {
                    setErrors({ ...errors, first_name: "" });
                    setProfileFieldData({
                      ...profileFieldData,
                      first_name: strFormat(e.target.value, "max:50"),
                    });
                  }}
                  error={errors?.first_name}
                />
                
                <Input
                  label={t("lastName") || "Last Name *"}
                  placeholder="Enter your last name"
                  required
                  value={profileFieldData?.last_name}
                  onChange={(e) => {
                    setErrors({ ...errors, last_name: "" });
                    setProfileFieldData({
                      ...profileFieldData,
                      last_name: strFormat(e.target.value, "max:50"),
                    });
                  }}
                  error={errors?.last_name}
                />

                {profileFieldData?.email ? (
                  <Input
                    label={t("email")}
                    readOnly={true}
                    value={profileFieldData?.email}
                    onChange={(e) => {
                      setErrors({ ...errors, email: "" });
                      setProfileFieldData({
                        ...profileFieldData,
                        email: strFormat(e.target.value, "max:50"),
                      });
                    }}
                    error={errors?.email}
                  />
                ) : null}

                {mobileStep == "old" ? (
                  <>
                    <MobileInput
                      label={t("mobile") || "Phone Number *"}
                      required
                      placeholder={"Enter Mobile"}
                      value={profileFieldData?.mobile_no}
                      readOnly="true"
                      endAdornment={
                        changeNumber == false &&
                        profileFieldData?.mobile_no.length == 9 ? (
                          <button
                            type="button"
                            onClick={SendOtp}
                            className="text-pink-600 hover:text-pink-700 transition-colors"
                          >
                            <Img
                              src="/images/editIcon.svg"
                              className="w-8 h-10"
                              alt="edit"
                            />
                          </button>
                        ) : null
                      }
                    />
                    {changeNumber ? (
                      <>
                        <Input
                          label={t("verificationCode")}
                          placeholder={t("enterVerificationCode")}
                          required
                          value={profileFieldData?.otp}
                          onChange={(e) => {
                            setProfileFieldData({
                              ...profileFieldData,
                              otp: strFormat(e.target.value, "max:4|number"),
                            });
                          }}
                          endAdornment={
                            profileFieldData?.otp.length > 3 ? (
                              <Text
                                className="text-center text-pink-800 text-sm w-auto cursor-pointer"
                                size="txtnunitoMedium14"
                                onClick={(e) => {
                                  setProfileFieldData({
                                    ...profileFieldData,
                                    type: "old",
                                  });
                                  setMobileStep("old");
                                  verifyOtp();
                                }}
                              >
                                {t("verify")}
                              </Text>
                            ) : null
                          }
                        />
                        <Text
                          className="text-left mb-6 rtl:text-right"
                          size="txtnunitoRegular16"
                        >
                          {t("didntGetACode")}
                          <Text
                            className={`text-pink-800 cursor-pointer p-1 ${
                              timer != 0 ? "opacity-down" : ""
                            }`}
                            size="txtnunitoRegular14Black900"
                            as="span"
                            onClick={SendOtp}
                          >
                            {t("resendCode")}
                          </Text>
                          <Text as="span" className="text-right">
                            {timer > 0 ? timer + ":00" : ""}
                          </Text>
                        </Text>
                      </>
                    ) : null}
                  </>
                ) : (
                  <>
                    <MobileInput
                      label={t("mobile")}
                      placeholder={t("enterNewMobile")}
                      required
                      value={profileFieldData?.mobile_no}
                      onChange={(e) => {
                        setErrors({ ...errors, mobile_no: "" });
                        setProfileFieldData({
                          ...profileFieldData,
                          mobile_no: strFormat(e.target.value, "number|max:9"),
                        });
                      }}
                      error={errors?.mobile_no}
                      endAdornment={
                        changeNumber == false &&
                        profileFieldData?.mobile_no.length > 8 ? (
                          <Text
                            className="text-center text-pink-800 text-sm w-auto cursor-pointer font-['Inter']"
                            onClick={SendOtp}
                          >
                            {t("verify")}
                          </Text>
                        ) : null
                      }
                    />
                    {changeNumber ? (
                      <>
                        <Input
                          label={t("verificationCode")}
                          placeholder={t("enterVerificationCode")}
                          required
                          value={profileFieldData?.otp}
                          onChange={(e) => {
                            setProfileFieldData({
                              ...profileFieldData,
                              otp: strFormat(e.target.value, "max:4|number"),
                            });
                          }}
                          endAdornment={
                            changeNumber == true &&
                            profileFieldData?.otp.length > 3 ? (
                              <Text
                                className="text-center text-pink-800 text-sm w-auto cursor-pointer"
                                size="txtnunitoMedium14"
                                onClick={(e) => {
                                  setProfileFieldData({
                                    ...profileFieldData,
                                    type: "new",
                                  });
                                  setMobileStep("new");
                                  updateMobileNo();
                                }}
                              >
                                Verify
                              </Text>
                            ) : null
                          }
                        />
                        <Text
                          className="text-left mb-6 rtl:text-right"
                          size="txtnunitoRegular16"
                        >
                          {t("didntGetACode")}
                          <Text
                            className={`text-pink-800 cursor-pointer p-1 ${
                              timer != 0 ? "opacity-down" : ""
                            }`}
                            size="txtnunitoRegular14Black900"
                            as="span"
                            onClick={SendOtp}
                          >
                            {t("resendCode")}
                          </Text>
                          <Text as="span" className="text-right">
                            {timer > 0 ? timer + ":00" : ""}
                          </Text>
                        </Text>
                      </>
                    ) : null}
                  </>
                )}

                <DatepickerInput
                  className="pointer-none"
                  label={t("dateOfBirth") || "Date of Birth *"}
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  value={profileFieldData?.dob ? profileFieldData?.dob : ""}
                  errorText={errors?.dob}
                  disableFuture="true"
                  endAdornment={
                    <Img
                      className="top-[0] my-auto"
                      src="/images/img_calendar_black_900.svg"
                      alt="Calendar"
                    />
                  }
                  onChange={(e) => {
                    setProfileFieldData({
                      ...profileFieldData,
                      dob: e == null || !e ? "" : e,
                    });
                    setErrors({ ...errors, dob: "" });
                  }}
                />
              </form>
            </div>

            {/* Modal Footer */}
            <div className="px-8 py-6 border-t border-gray-200 flex items-center justify-between gap-4">
              <Button
                type="button"
                size="md"
                variant="OutlineBlack"
                className="flex-1 font-['Unbounded'] border-1 radius-20 rounded-full "
                disabled={changeNumber || mobileStep == "new"}
                onClick={(e) => {
                  navigate("/delete-account");
                }}
              >
                {t("deleteAccount")}
              </Button>
              <Button
                size="md"
                variant="FillBlack"
                className="bg-[#84294B] flex-1 font-['Unbounded'] border-0 rounded-full hover:bg-[#84294B]/90 transition-colors"
                disabled={changeNumber || mobileStep == "new"}
                onClick={updateProfile}
              >
                {t("save") || "Save Edits"}
              </Button>
            </div>
          </div>
        </Modal>
      ) : null}

      <style jsx>{`
        /* Custom scrollbar for modal */
        .overflow-y-auto::-webkit-scrollbar {
          width: 6px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 3px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }

        /* Smooth animations */
        .MuiModal-root {
          animation: fadeIn 0.3s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

export default ProfileEdit;
